import { useLocation } from 'react-router-dom';
import { useCallback, useEffect, useMemo, useState } from 'react';

import { preparePageNumber } from '../preparePageNumber';
import { prepareListingOrdering } from '../prepareListingOrdering';

interface IUseQueryStringKeyParams {
  rubricId?: number;
  category?: string;
}
/**
 * Генерирует строку из чувствительных значений для запроса
 * к апи-ручкам листингов с целью блокировки повторных вызовов
 */
export const useQueryStringKey = (params?: IUseQueryStringKeyParams) => {
  const { search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const mkKey = useCallback(
    () =>
      `${preparePageNumber(searchParams.get('page') || '')}|${searchParams.get('with-tag') || ''}|${
        prepareListingOrdering(searchParams.get('ordering') || '') || ''
      }|${params?.rubricId || ''}|${params?.category || ''}`,
    [params?.category, params?.rubricId, searchParams],
  );
  const [key, setKey] = useState(mkKey());

  useEffect(() => {
    const keyNew = mkKey();

    if (keyNew === key) {
      return;
    }

    setKey(keyNew);
  }, [key, mkKey]);

  return key;
};
